<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="max-width: 1200px" py-5>
                    <h1 class="pt-5 pb-5">Регистрация</h1>

                    <v-layout v-if="isAdmin" row wrap pb-5>
                        <v-flex xs12 py-0>
                            <v-autocomplete
                                v-model="curatorId"
                                :items="curatorsList"
                                label="Куратор"
                                :rules="[rules.notNullOrEmpty]"
                                required
                                item-value="value"
                                item-text="text"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout v-if="isAdmin && curatorId === 0" row wrap pb-5>
                        <v-flex xs12 sm6 py-0>
                            <v-checkbox
                                v-model="user.is_egarant"
                                label="Е-Гарант"
                            />
                        </v-flex>
                        <v-flex v-if="user.is_egarant" xs12 sm6 py-0>
                            <v-select
                                v-model="user.egarant_company"
                                :items="egarantCompaniesList"
                                :rules="[rules.required]"
                                item-text="name"
                                item-value="id"
                                label="Компания для Е-Гарант"
                                required
                            />
                        </v-flex>
                    </v-layout>

                    <v-radio-group v-if="!isEgarant" v-model="type" row  v-on:change="changeType">
                        <v-radio label="Физ. Лицо"
                                :value="'physical'">
                        </v-radio>
                        <v-radio label="Юр. Лицо"
                                :value="'juridical'">
                        </v-radio>
                        <v-radio label="ИП"
                                :value="'sole-proprietor'">
                        </v-radio>
                        <v-radio label="Самозанятый"
                                :value="'self-employed'">
                        </v-radio>
                    </v-radio-group>

                    <h3 class="pt-5 pb-4">Ваши данные</h3>

                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.surname"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.name"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.patronymic"
                                label="Отчество"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pb-2>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="user.phone"
                                :rules="[rules.phone]"
                                mask="+7 ### ### ## ##"
                                label="Телефон"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0>
                            <v-text-field
                                v-model="user.email"
                                :rules="[rules.email]"
                                label="Е-mail (является логином для входа в ЛК)"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12 lg4 py-0>
                            <osago-city-dadata :model="city"></osago-city-dadata>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pb-2 v-if="curatorId !== 0">
                        <v-flex xs12 md6 lg4 py-0>
                            <v-select
                                v-model="user.sales_type"
                                label="Тип продаж"
                                :items="salesTypesArray"
                                :rules="[rules.required]"
                                validate-on-blur
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0 v-if="user.sales_type === 'transit'">
                            <v-autocomplete
                                v-model="user.border_crossing_id"
                                label="Пограничный переход"
                                :items="borderCrossingsArray"
                                :rules="[user.sales_type === 'transit' ? rules.required : null]"
                                validate-on-blur
                                required
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>

<!--                    <div v-if="!isEgarant">
                        <h2 class="pt-5 pb-4">Платёжные реквизиты</h2>

                        <v-layout row wrap pt-2 pb-2>
                            <v-flex xs12 sm9 md8 lg7 py-0>
                                <p style="font-size: 18px"><b>ВНИМАНИЕ:</b> Указываете настоящие данные, без опечаток. ФИО должны совпадать
                                с владельцем карты/счета. Указывайте именно ваши данные, НЕ брата, сестры,
                                тещи и т.п. В противном случае, мы не сможем сделать вам выплату.</p>
                            </v-flex>
                        </v-layout>

                        <v-checkbox v-if="type == 'juridical'" pb-5
                                    label="Упрощенная система налогообложения"
                                    v-model="jur.simple_tax_system"
                                    @change=""
                        ></v-checkbox>

                        <v-layout row wrap>
                            <v-flex v-if="type == 'juridical'" xs12 md12 lg12 py-0>
                                <v-text-field
                                    v-model="jur.name"
                                    :rules="[]"
                                    label="Название Юр лица"
                                    validate-on-blur
                                ></v-text-field>
                            </v-flex>
                            <v-flex v-if="type == 'sole-proprietor'" xs12 md12 lg12 py-0>
                                <v-text-field
                                    v-model="jur.name"
                                    :rules="[]"
                                    label="Наименование ИП"
                                    validate-on-blur
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg4 py-0
                                v-if="type !== 'juridical'"
                            >
                                <v-text-field
                                    v-model="passport.series_number"
                                    :rules="[rules.passport]"
                                    label="Серия и номер паспорта"
                                    mask="#### ######"
                                    return-masked-value
                                    validation-on-blur
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg4 py-0
                                v-if="type !== 'juridical'"
                            >
                                <osago-date
                                    v-model="birthday"
                                    label="Дата рождения"
                                    :max="passportMaxDate"
                                    :isRequired="false"
                                />
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg4 py-0>
                                <osago-address-dadata
                                    :model="address"
                                    :label="'Почтовый адрес'"
                                    :isRequired="false"
                                />
                            </v-flex>
                            <v-flex v-if="type !== 'juridical'" xs12 md6 lg4 py-0>
                                <v-text-field
                                    v-model="snils"
                                    :rules="[]"
                                    label="СНИЛС"
                                    mask="###-###-### ##"
                                    validate-on-blur
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg4 py-0>
                                <v-text-field
                                    v-if="type === 'juridical'"
                                    v-model="bank.inn"
                                    :rules="[validateInn]"
                                    label="ИНН"
                                    mask="##########"
                                    validate-on-blur
                                ></v-text-field>
                                <v-text-field
                                    v-if="type !== 'juridical'"
                                    v-model="bank.inn"
                                    :rules="[rules.inn, validateInn]"
                                    label="ИНН"
                                    mask="############"
                                    validate-on-blur
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 md12 lg12 py-0>
                                <v-text-field
                                    v-model="bank.name"
                                    :rules="[]"
                                    label="Название банка"
                                    validate-on-blur
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg4 py-0>
                                <v-text-field
                                    v-model="bank.bik"
                                    :rules="[rules.bik]"
                                    mask="#########"
                                    label="БИК банка"
                                    validate-on-blur
                                    autocomplete="new"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg4 py-0>
                                <v-text-field
                                    v-model="bank.account_number"
                                    :rules="[rules.accNumber]"
                                    mask="####################"
                                    label="Номер расчетного счета"
                                    validate-on-blur
                                    autocomplete="new2"
                                ></v-text-field>
                                <v-text-field
                                    hidden
                                    disabled
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </div>-->


                    <h3 class="pt-5 pb-3">Пароль</h3>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password"
                                :rules="[rules.password]"
                                label="Пароль (не менее 7 символов)"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer" @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password_check"
                                :rules="[passwordCheckRule]"
                                label="Повторите пароль"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer" @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout pt-5 pb-2 row wrap>
                        <v-flex xs12>
                            <v-checkbox
                                v-model="profileApproved"
                                :rules="[rules.approve]"
                                validate-on-blur
                            >
                                <template v-slot:label>
                                    Подтверждаю достоверность указанных данных
                                </template>
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout pt-5 pb-5 row wrap>
                        <v-flex xs12 lg6>
                            <v-btn @click="validate"
                                   :disabled="false"
                                   class="submit-button block">Отправить</v-btn>
                        </v-flex>
                        <v-flex xs12 lg6>
                            <div class="policy-wrapper">
                                Отправляя анкету, соглашаюсь
                                <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                                обработки персональных данных</a>
                                <br>и даю 
                                <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                    Согласие на обработку персональных данных
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <h2 class="pt-5 pb-3">Возникли вопросы?</h2>
                    <v-layout row wrap pb-5>
                        <v-flex xs12 sm9 md8 lg7 py-0>
                            <h3><a href="tel:88002010643">8 800 201 06 43</a></h3>
                            <p style="font-size: 18px">Звоните, и наши менеджеры прояснят все моменты.</p>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
    import moment from "moment";
    export default {
        props: ['is-admin', 'curator', 'curator-is-egarant', 'curators', 'egarant-companies', 'sales-types', 'border-crossings'],

        data: () => ({
            valid: true,
            curatorId: null,
            curatorEgarant: false,
            curatorsList: [],
            salesTypesList: [],
            borderCrossingsList: [],
            type: 'physical',
            profileApproved: false,
            egarantCompaniesList: [],
            passportMaxDate: null,
            user: {
                phone: '+7',
                email: '',
                password: '',
                password_check: '',
                is_egarant: false,
                egarant_company: 0,
                border_crossing_id: null,
                sales_type: null,
            },
            fio: {
                name: '',
                surname: '',
                patronymic: '',
            },
            snils: null,
            birthday: null,
            address: {
                search: '',
            },
            passport: {
                series_number: '',
                date: '',
                issued_by: '',
                address: {},
            },
            city: {
                city: '',
                search: '',
                city_kladr: null,
                city_fias: null
            },
            bank: {
                inn: '',
                name: '',
                account_number: '',
                bik: '',
                kor_account: '',
            },
            jur: {
                simple_tax_system: false,
                fact_addr_eq_jur: false,
                name: '',
                kpp: '',
                ogrn: '',
                address: {},
                fact_address: {},
            },

            rules: {
                required: v => !!v || 'Обязательное поле',
                integer: v => Number.isInteger(v) || 'Обязательное поле',
                passport: v => v === null || v === '' || /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
                password: v => v.length >= 7 || 'Пароль должен содержать не менее 7 символов',
                ogrn: v => v === null || v === '' || /^(\d{13}|\d{15})$/.test(v) || 'Должен содержать 13 или 15 цифр',
                inn: v => v === null || v === '' || /^\d{12}$/.test(v) || 'Должен содержать 12 цифр',
                innJuridical: v => /^\d{10}$/.test(v) || 'Должен содержать 10 цифр',
                kpp: v => v === null || v === '' || /^\d{9}$/.test(v) || 'Должен содержать 9 цифр',
                bik: v => v === null || v === '' || /^\d{9}$/.test(v) || 'Должен содержать 9 цифр',
                accNumber: v => v === null || v === '' || /^\d{20}$/.test(v) || 'Должен содержать 20 цифр',
                notNullOrEmpty: v => (v !== null && v !== '') || 'Обязательное поле',
                approve: v => v || 'Необходимо согласиться',
            },

            showPass: false,
        }),

        computed: {
            areaItems() {
                return this.area.entries.map(entry => {
                    const Description = entry.value;
                    return Object.assign({}, entry, {Description})
                })
            },

            passwordCheckRule() {
                return () => this.user.password === this.user.password_check || 'Пароли не совпадают';
            },

            isEgarant() {
                return this.user.is_egarant;
            },

            validateInn() {
                let result = false;
                let inn = this.bank.inn;
                if (!inn.length) {
                    return true; // Конкретно в этом случае пропускаем валидацию
                } else if (/[^0-9]/.test(inn)) {
                    return 'ИНН может состоять только из цифр';
                } else if ([10, 12].indexOf(inn.length) === -1) {
                    return 'ИНН может состоять только из 10 или 12 цифр';
                } else {
                    const checkDigit = function (inn, coefficients) {
                        let n = 0;
                        for (const i in coefficients) {
                            n += coefficients[i] * inn[i];
                        }
                        return parseInt(n % 11 % 10);
                    };
                    switch (inn.length) {
                        case 10:
                            const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
                            if (n10 === parseInt(inn[9])) {
                                result = true;
                            }
                            break;
                        case 12:
                            const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                            const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                            if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                                result = true;
                            }
                            break;
                    }
                    if (!result) {
                        return 'Неправильный ИНН';
                    }
                }
                return result;
            },
            salesTypesArray() {
                return Object.entries(this.salesTypesList).map(([value, text]) => ({
                    value,
                    text
                }));
            },
            borderCrossingsArray() {
                return Object.entries(this.borderCrossingsList).map(([value, text]) => ({
                    value,
                    text
                }));
            },
        },

        created: function () {
            this.passportMaxDate = moment().format('YYYY-MM-DD');

            this.curatorId = this.curator;
            if (this.curatorId !== null) {
                this.user.is_egarant = this.curatorEgarant = !!this.curatorIsEgarant;
            }
            if (this.isAdmin) {
                this.curatorsList = JSON.parse(window.atob(this.curators));
                this.egarantCompaniesList = JSON.parse(window.atob(this.egarantCompanies));
            }
            this.salesTypesList = JSON.parse(this.salesTypes)
            this.borderCrossingsList = JSON.parse(this.borderCrossings)
        },

        mounted: function () {
            //window.tippy.default('.tip-icon');
        },

        watch: {
            /*areaSearch(searchQuery) {
                this.getSuggestions(searchQuery, 'area');
            },*/
        },

        methods: {
            changeType(value) {
                if (value == 'juridical' && this.bank.inn.length > 10) {
                    this.bank.inn = this.bank.inn.slice(0,10)
                }
            },

            validate() {
                if (this.$refs.form.validate()) {
                    this.submit();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.goToFirstError();
                    });
                }
            },

            goToFirstError() {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            submit() {
                let jur = (this.type == 'juridical' || this.type == 'sole-proprietor') && !this.isEgarant ? this.jur : null;

                let passport = _.cloneDeep(this.passport);

                if (passport.address) {
                    passport.address = passport.address.search;
                }
                let user = _.clone(this.user);
                if (this.user.egarant_company === 0) {
                    user.egarant_company = null;
                }

                axios.post(window.location, {
                    curator_id: this.curatorId,
                    type: this.type,
                    user: user,
                    fio: this.fio,
                    snils: this.snils,
                    birthday: this.birthday,
                    address: this.address.search,
                    passport: passport,
                    city: this.city,
                    bank: this.bank,
                    jur: jur,
                    profileApproved: this.profileApproved,
                }).then(response => {
                    window.location.href = response.data.redirectTo;
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                });
            },

        }
    }
</script>

<style scoped>
    a.policy {
        color: #00ba57;
    }

    .policy-wrapper {
        text-align: left;
        display: table-cell;
        vertical-align: middle;
        height: 100px;
    }

    .driverControls a {
        color: #000000;
    }

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 24px !important;
        text-transform: none !important;
        box-shadow: none !important ;

        height: 100px;
        background-color: #00ba57 !important;;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 200px;
        line-height: 1.1;
    }

    .preview-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 19px !important;
        text-transform: none !important;
        box-shadow: none !important ;

        height: 70px;
        width: 90%;
        background-color: #00ba57 !important;;
        text-align: center;
        padding: 0 30px !important;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;

        /*        font-size: 46px;
                line-height: 1.55;
                font-weight: 400;*/
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    .preloading {
        position: relative;
        z-index: 999;
        height: 100%;
        width: 100%;
        max-width: 100%;
        overflow: visible;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        background: white;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .preloader-circle {
        background: #00ba57;
        width: 100px;
        height: 100px;
        margin: auto;
        border-radius: 100%;
        -webkit-animation:grow 1s infinite;
    }

    .pointer {
        cursor: pointer;
    }

    @-webkit-keyframes grow {
        0% {
            -webkit-transform: scale( 0.7 )
        }

        50% {
            -webkit-transform: scale( 0.9 )
        }

        100% {
            -webkit-transform: scale( 0.7 )
        }
    }

    /deep/ .preview-text-label {
        color: #585858;
        font-size: 12px;
    }

    h3 a {
        color: #000;
        text-decoration: none;
    }

    h3 a:hover {
        color: #000;
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/RegisterAgent.vue